import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";
import Layout from "../components/layout";
import { showLoading, hideLoading } from "../redux/alertsSlice";
import { Form, Input, Button, Select, Card, Rate, } from "antd";
import toast from "react-hot-toast";

const { Option } = Select;

function SubmitReview() {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [appointments, setAppointments] = useState([]);
  
    useEffect(() => {
      const fetchData = async () => {
        try {
          dispatch(showLoading());
          const appointmentsResponse = await axios.get("/api/user/get-appointments-by-user-id", {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          });
          dispatch(hideLoading());
          setAppointments(appointmentsResponse.data.data || [] );
        } catch (error) {
          toast.error("Failed to fetch data");
          dispatch(hideLoading());
          console.error("Failed to fetch data:", error); // Debug log
        }
      };
  
      fetchData();
    }, [dispatch]);
  
    const submitReview = async (values) => {
      try {
        dispatch(showLoading());
        const response = await axios.post(
          "/api/bookAppointment/submit-review",
          values,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        dispatch(hideLoading());
        if (response.data.success) {
          toast.success(response.data.message);
          form.resetFields();
        }
      } catch (error) {
        toast.error("Something went wrong");
        dispatch(hideLoading());
        console.error("Error submitting review:", error); // Debug log
      }
    };
  
    return (
   <Layout>
  <div style={{ maxWidth: '600px', margin: '40px auto' }}>
    <Card
      title="Submit Doctor Review"
      bordered={false}
      style={{
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        borderRadius: "10px",
        padding: "24px"
      }}
    >
      <Form form={form} layout="vertical" onFinish={submitReview}>
        <Form.Item
          name="appointmentId"
          label="Appointment by Doctor"
          rules={[{ required: true, message: "Please select an appointment" }]}
        >
          <Select placeholder="Select a doctor by appointment">
            {Array.isArray(appointments) && appointments.length > 0 ? (
              appointments.map((appointment) => (
                <Option key={appointment._id} value={appointment._id}>
                  {appointment.doctorInfo.firstName || "Unknown Doctor"}{" "}
                  {appointment.doctorInfo.lastName || "Unknown Doctor"} -{" "}
                  {appointment.doctorInfo.service || "Unknown Service"}
                </Option>
              ))
            ) : (
              <Option disabled>No appointments available</Option>
            )}
          </Select>
        </Form.Item>

        <Form.Item
          name="rating"
          label="Doctor Rating"
          rules={[{ required: true, message: "Please provide a rating" }]}
        >
          <Rate />
        </Form.Item>

        <Form.Item
          name="comment"
          label="Comment"
          rules={[{ required: true, message: "Please provide a comment" }]}
        >
          <Input.TextArea rows={4} placeholder="Add a comment..." />
        </Form.Item>

        <Form.Item>
          <Button type="primary" className="btn-primary" htmlType="submit">
            Submit Review
          </Button>
        </Form.Item>
      </Form>
    </Card>
  </div>
</Layout>
    );
  }
  
  export default SubmitReview;